import { render, staticRenderFns } from "./TableAcesso.vue?vue&type=template&id=22b838cc&scoped=true&"
import script from "./TableAcesso.vue?vue&type=script&lang=js&"
export * from "./TableAcesso.vue?vue&type=script&lang=js&"
import style0 from "./TableAcesso.vue?vue&type=style&index=0&id=22b838cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b838cc",
  null
  
)

export default component.exports